ixModuleRouting("impactx.compilationarticle", {
    "/compilation/:proId": {
        template: "<ixa-compilation-article-view></ixa-compilation-article-view>",
        templateUrl:
            "modules/compilationarticle/templates/compilationarticleview.html",
        controller: "CompilationArticleViewCtrl",
        controllerAs: "compilationArticleViewCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/compilationarticle/:catId/:proId": {
        template: "<ixa-compilation-article></ixa-compilation-article>",
        templateUrl:
            "modules/compilationarticle/templates/compilationarticle.html",
        controller: "CompilationArticleCtrl",
        controllerAs: "compilationArticleCtrl",
        process: "EditCompilationArticle",
        workspace: "content",
    },
});
